import { render, staticRenderFns } from "./AgentOrderView.vue?vue&type=template&id=03201598"
import script from "./AgentOrderView.vue?vue&type=script&lang=ts"
export * from "./AgentOrderView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports